import { IS_UAE_ENV } from '@modules/core/utils';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { useLocation } from '@tanstack/react-router';
import usePersistUser from '@modules/core/hooks/usePersistUser';
import useGetBrokerProfile from '@modules/core/hooks/queries/useGetBrokerProfile';
import { ReferAndEarnLaunch } from './ReferAndEarnLaunch';
import useAnnouncements from '../hooks/useAnnouncements';

export const Announcements = (): React.JSX.Element => {
  const { hash } = useLocation();
  const { user } = usePersistUser();
  const { data: brokerProfile } = useGetBrokerProfile(user?.id);
  const { isFeatureFlagsLoading } = useFeatureFlags();

  const [showReferAndEarn] = useAnnouncements('referAndEarn');

  // Don't show announcements if there's a hash in the URL
  // Prevents slidos from showing when another slido might be opened
  if (hash || isFeatureFlagsLoading || !brokerProfile) {
    return <></>;
  }

  const shouldShowReferAndEarn = IS_UAE_ENV
    && showReferAndEarn
    && brokerProfile?.terms_conditions_version === TERMS_AND_CONDITIONS_VERSION;

  return (
    <>
      {shouldShowReferAndEarn && <ReferAndEarnLaunch defaultOpen />}
    </>
  );
};
